export const openLicenseFile = () => {
    fetch("/LICENSE.txt")
        .then((response) => {
            if (!response.ok) {
                throw new Error("Impossibile caricare il file LICENSE.txt");
            }
            return response.text();
        })
        .then((text) => {
            const newWindow = window.open("", "_blank");

            if (newWindow) {
                const content = `
            <!DOCTYPE html>
            <html lang="it">
            <head>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>License</title>
                <style>
                    body {
                        font-family: "Courier New", Courier, monospace;
                        font-size: 11px;
                        white-space: pre-wrap;
                        margin: 20px;
                    }
                </style>
            </head>
            <body>
                <pre>${text}</pre>
            </body>
            </html>
          `;

                newWindow.document.open();
                newWindow.document.write(content);
                newWindow.document.close();
            } else {
                alert("Il browser ha bloccato l'apertura della finestra.");
            }
        })
        .catch((error) => {
            alert("Errore: " + error.message);
        });
};
